import { Component, OnInit, Inject, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Store } from 'redux';
import { AppStore } from '../../app.store';
// import { UsersState } from '../../_model/user/user.reducer';
import { User } from '../../_model/user/user.model';
import { UserService } from '../../_service/user/user.service';
import { Utility } from 'app/_service/utility';
import { Unsubscribable } from 'rxjs';
import { StorageService } from '../../storageprovider';
import { RechargeBoxService } from 'app/_service/recharge-box/recharge-box.service';
import { RechargeService } from '../../_service/recharge/recharge.service';

@Component({
  selector: 'app-mycard',
  templateUrl: './mycard.component.html',
  styleUrls: ['./mycard.component.scss']
})

export class MycardComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    this.subscriptions.forEach(p => p.unsubscribe());
  }
  //allVip = false;
  user;
  @Input()
  hide = true;

  @Output('hideMyCardEvent')
  hideMyCardEvent = new EventEmitter<any>();
  cardBackground: any;
  isDark = false;
  discountText = '';
  discountPerday = '';
  constructor(
    private _userService: UserService,
    private _storage: StorageService,
    private _utility: Utility,
    private _rechargeBoxService: RechargeBoxService,
    private _rechargeService:RechargeService
    // @Inject(AppStore) private store: Store<UsersState>,
  ) {
    //this.isDark = Utility.isDarkMode();
  }
  private subscriptions: Array<Unsubscribable> = [];
  ngOnInit() {
    //console.log("mycard init")
    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"] || "1");
    this.user = this._userService.user;
    this.subscriptions.push(
      this._userService.userState$.subscribe(user => {
      this.user = user;
      this.readState();
      }),
      this._rechargeService.productState$.subscribe(p=>{
        if(!p.hasValue)
        {
          return;
        }
        this.discountText = !!p.state.shareSale ? p.state.shareSale : '';
        if (p.state.products.length > 0) {
          const result = p.state.products[p.state.products.length - 1];
          const priceEUR = result.priceTag.split('/')[0].replace(/[^\d.]/gi, '');
          const normalDays = Number(result.productName.split('+')[0].replace(/[^\d.]/gi, ''));
          const bonusDays = result.productName.split('+')[1] !== undefined ? Number(result.productName.split('+')[1].replace(/[^\d.]/gi, '')) : 0;
          const mutupleDevice = !!result.mutupleDevice ? result.mutupleDevice : false;
          this.discountPerday = (priceEUR / (normalDays + bonusDays) / (mutupleDevice ? 2 : 1)).toFixed(2);
        }
      }),
      // this._utility.GetOrCreateSubscript("on.obtainpayment").subscribe(p => {
     
      // }),
      this._utility.GetOrCreateSubscript("theme.change").subscribe(theme => {
        if (theme == "dark") {
          this.isDark = true;
        }
        else {
          this.isDark = false;
        }
        this.readState();
      })

    )
    this.readState();

    // this.unsb = this.store.subscribe(() => this.readState());
    // this.readState();
  }

  readState() {
    // const configState = this.store.getState()['config'];
    // if (configState.config.allVip) {
    //   this.allVip = true;
    // }
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = new User(true);
    // Object.assign(this.user, state.currentUser);
    this.cardBackground = this.isDark ? `assets/images/user-bg.png` : `assets/images/user-bg-light.png`;
  }

  hideMyCard() {
    this.hideMyCardEvent.emit(true);
  }

  logout() {
    // if (window['DN_Logout']) {
    //   window['DN_Logout']();
    // }
    // console.log("isme 12");

    this._userService.logout();
  }

  login() {
    this._userService.showLoginDialog(true);
  }

  openRechargeBox() {
    this._rechargeBoxService.changeDisplayStatus(true);
  }
}
